String.prototype.regexpAccentify = function () {
	return this.toString()
		.toLowerCase()
		.replace(/([\u00C0-\u00C6]|a|A)/gi, '([\u00C0-\u00C6]|a|A)')
		.replace(/([\u00C8-\u00CB]|e|E)/gi, '([\u00C8-\u00CB]|e|E)')
		.replace(/([\u00CC-\u00CF]|i|I)/gi, '([\u00CC-\u00CF]|i|I)')
		.replace(/([\u00D2-\u00D6]|o|O)/gi, '([\u00D2-\u00D6]|o|O)')
		.replace(/([\u00D9-\u00DC]|u|U)/gi, '([\u00D9-\u00DC]|u|U)');
};
